module.exports = __webpack_public_path__ + "static/media/dysway_logo-white.01aba79a.png";